import { Component, Input, OnInit } from "@angular/core";
import { AlertController, ModalController, Platform, ToastController} from "@ionic/angular";
import { Store } from "@ngrx/store";
import { AppModeService } from "src/app/angular-wallet-base/services/app-mode.service";
import { getSideMenuStatus } from "src/app/angular-wallet-base/store/appSettings";
import { AppState } from "src/app/angular-wallet-base/store/appState";
import { take } from 'rxjs/operators';
import { SuccessDepositModalComponent } from "../success-deposit-modal/success-deposit-modal";
import { FormBuilder, Validators } from "@angular/forms";
import { BankAccountService } from "src/app/angular-wallet-base/services/bank-account.service";
import { TranslateService } from "@ngx-translate/core";
import { confirmstartKycAlert, createBankAccountServiceUnavailableAlert, getToastPosition, presentAlert } from "src/app/angular-wallet-base/utils";
import { SubscriptionListenerComponent } from "src/app/angular-wallet-base/SubscriptionListenerComponent";
import { getServiceStatus } from "src/app/angular-wallet-base/store/connection";
import { GetBankAccountBalanceRequest, GetBankAccountRequestAction, GetBankAccountTransactionHistoryRequest, GetBankingHistoryAction } from "src/app/angular-wallet-base/actions/bankAccount.actions";
import { getBankAccountList } from "src/app/angular-wallet-base/store/bankAccounts";
import { Logger } from "src/app/angular-wallet-base/services/logger.service";



@Component({
    selector: "app-deposit-funds-page",
    templateUrl: "./deposit-withdraw-funds-modal.html",
    styleUrls: ["./deposit-withdraw-funds-modal.scss"],
})
export class DepositFundsModalComponent extends SubscriptionListenerComponent implements OnInit {
    public isDesktopMode = false;
    public isBankAccountLinked :boolean;
    @Input() action: string;
    @Input() bankAccounts:Array<any>;

    public services;
    public form;
    public isClicked = false;
    titleOfPage:string='';

    //for success modal
    totalToShow
    isSuccess
    title
    subtitle
    message
constructor(
        private formBuilder: FormBuilder,
        private platform: Platform,
        private toast: ToastController,
        private bankAccountService: BankAccountService,
        private translate: TranslateService,
        private alert: AlertController,
        protected store: Store<AppState>,
        public alertController: AlertController,
        public appMode: AppModeService,
        public modalController: ModalController,
    ) {
        super(store);
        this.appMode.isDesktopMode.subscribe(mode => this.isDesktopMode = mode);

    }

    async ngOnInit() {
      this.titleOfPage = this.action === 'deposit'?
      await this.translate.get('deposit_withdraw.title1').toPromise():
      await this.translate.get('deposit_withdraw.title2').toPromise();
      this.initForm();

      this.subscriptions.add(this.store.select(getServiceStatus).subscribe(data => {
        this.services = data;
      }));
      this.isBankAccountLinked = this.bankAccounts.length > 0 ? true: false;
      this.subscriptions.add(this.store.select(getBankAccountList).subscribe((bankAccount) => {
        this.bankAccounts = bankAccount.data;
        this.isBankAccountLinked = this.bankAccounts.length > 0 ? true: false;
      }));
    }
    initForm() {
      this.form = this.formBuilder.group({
        amount: ['', Validators.required],
        transferMethodId: ['', Validators.required],
      });
    }
  
    closeModal() {
        this.modalController.dismiss();
      }
      async openSuccess(){
        this.modalController.dismiss();
        let cssClass = '';
        const sideMenuHidden = await this.store.select(getSideMenuStatus).pipe(take(1)).toPromise();
        cssClass += (this.isDesktopMode) ? 'deposit-modal-desktop' : 'deposit-modal';
        cssClass += (!sideMenuHidden && this.isDesktopMode) ? ' with-side-menu' : '';
        const modal = await this.modalController.create({
          component: SuccessDepositModalComponent,
          componentProps:{
            totalToShow:this.totalToShow,
            title:this.title,
            subtitle:this.subtitle,
            message:this.message,
            isSuccess:this.isSuccess,
            action:this.action
          },
          cssClass,
          initialBreakpoint: (this.isDesktopMode) ? undefined : 0.7,
          breakpoints: (this.isDesktopMode) ? undefined : [0,0.7,1],
          id: 'depositsuccessModal'
        });
        await modal.present();
      }
      
      async linkBankAccount(){
        try {
          const onLinkSuccess = () => {
            this.store.dispatch(new GetBankAccountRequestAction());
            this.presentToast('deposit_success_fail.ok_hdr','deposit_success_fail.link_bank_acct_msg');
          };
          const onLinkError = (e) => {
            if(e.error && e.error.errors){
              switch (e.error.errors) {
                case "You have already linked an item at this institution.":
                  presentAlert(this.alert, this.translate, null, 'deposit_success_fail.err_hdr', 'deposit_success_fail.already_link_account_message', 'btn_back');

                  break;
                  case "Unable to create funds transfer method.":
                    presentAlert(this.alert, this.translate, null, 'deposit_success_fail.err_hdr', 'deposit_success_fail.unable_deposit', 'btn_back');
  
                    break;
              
                default:
                  this.presentToast('deposit_success_fail.err_hdr','deposit_success_fail.link_bank_acct_err_msg');

                  break;
              }
            } else {
              this.presentToast('deposit_success_fail.err_hdr','deposit_success_fail.link_bank_acct_err_msg');
            }
          };
          await this.bankAccountService.linkPlaidAcc(onLinkSuccess, onLinkError);
        } catch(e) {
          if(e.status === 403) {
            const handler = async (data) => {
              this.bankAccountService.startKyc(JSON.parse(e.error));
              // await this.nav.navigateForward('/setup/setup-pin/recover', { queryParams: { restore: true} });
            };
            confirmstartKycAlert(this.alert, this.translate, handler);
            
            return;
          }
          if(e.status === 422) {
            Logger.info(e.error);
            this.bankAccountService.showKYCStatus(JSON.parse(e.error));
            // await this.nav.navigateForward('/setup/setup-pin/recover', { queryParams: { restore: true} });
            return
    
          }
          if(e.error){
            Logger.info(e)
            const err = JSON.parse(e.error)
            if(err.errors === "Must be a US Resident to link a bank account.")
              presentAlert(this.alert, this.translate, null, 'deposit_success_fail.non_us_account_title', 'deposit_success_fail.non_us_account_message', 'btn_back');
            else 
              this.presentToast('deposit_success_fail.err_hdr','deposit_success_fail.link_bank_acct_err_msg');
          } else {
            this.presentToast('deposit_success_fail.err_hdr','deposit_success_fail.link_bank_acct_err_msg');
          }    
        }
      }
      async presentToast(hdr,msg) {
        const toast = await this.toast.create({
          header: await this.translate.get(hdr).toPromise(),
          message: await this.translate.get(msg).toPromise(),
          position: getToastPosition(this.platform),
          duration: 4000
        });
        await toast.present();
      }
      onSubmit() {
        this.isClicked = true; 
        if(this.action === 'deposit') {
          this.callDeposit();
        } else {
          this.callWithdraw();
        }
      }
      async callDeposit() {
        try {
          let data:any;
          data = await this.bankAccountService.depositFunds(this.form.value);
          this.store.dispatch(new GetBankAccountBalanceRequest());
          //need to remove
          this.store.dispatch(new GetBankAccountTransactionHistoryRequest());
          const bankingHistoryProgress = this.bankAccountService.bankingHistoryProgress.getValue();
          if (!bankingHistoryProgress) { this.store.dispatch(new GetBankingHistoryAction()); };

          this.totalToShow = data.attributes.amount;
          this.isSuccess = true;
          this.title = await this.translate.get('deposit_success_fail.success').toPromise();
          this.subtitle = await this.translate.get(
            this.action === 'deposit' ? 'deposit_success_fail.deposit_success' 
            : 'deposit_success_fail.widthdraw_success').toPromise();
          this.message = await this.translate.get('deposit_success_fail.funds_will_be_available').toPromise();
          this.openSuccess();
        } catch (err) {
          Logger.info(err);
          this.title = await this.translate.get(this.action === 'deposit' ? 'deposit_success_fail.deposit_error' 
          : 'deposit_success_fail.withdraw_error').toPromise();
          this.subtitle = await this.translate.get(this.action === 'deposit' ? 'deposit_success_fail.could_not_deposit' 
          : 'deposit_success_fail.could_not_withdraw').toPromise()
          this.isSuccess = false;
          this.openSuccess();
        }
      }
    
      async callWithdraw() {
        try {
          let data:any;
          await this.bankAccountService.approveKycAndAml();
          data = await this.bankAccountService.withdrawFunds(this.form.value);
          this.store.dispatch(new GetBankAccountBalanceRequest());
          //need to remove
          this.store.dispatch(new GetBankAccountTransactionHistoryRequest());
          const bankingHistoryProgress = this.bankAccountService.bankingHistoryProgress.getValue();
          if (!bankingHistoryProgress) { this.store.dispatch(new GetBankingHistoryAction()); };

          this.totalToShow = data.attributes.amount;
          this.isSuccess = true;
          this.title = await this.translate.get('deposit_success_fail.success').toPromise();
          this.subtitle = await this.translate.get(this.action === 'deposit' ? 'deposit_success_fail.deposit_success' 
          : 'deposit_success_fail.widthdraw_success').toPromise();
          this.message = await this.translate.get('deposit_success_fail.funds_will_be_available').toPromise();
          this.openSuccess();
        } catch (err) {
          Logger.info(err);
          this.title = await this.translate.get(this.action === 'deposit' ? 'deposit_success_fail.deposit_error' 
          : 'deposit_success_fail.withdraw_error').toPromise();
          this.subtitle = await this.translate.get(this.action === 'deposit' ? 'deposit_success_fail.could_not_deposit' 
          : 'deposit_success_fail.could_not_withdraw').toPromise()
          this.isSuccess = false;
          this.openSuccess();
        }
      }
           
}
